<script>
  import MetadataOperations from "./metadataOperations.svelte"
  import templateStore from "../../../../../Stores/metadataStore"
  // import { afterUpdate } from "svelte"

  export let json = {}
  export let namespace = ""

  /**
   * @type {Boolean} - to check key input has a value or not and disabled addrow button for no value
   */
  let checkKeyValue = true

  /**
   * Function to add a new row to the template data.
   * @param {string} namespace - The namespace of the new row. Defaults to `namespace`.
   */
  const addRow = (namespace = namespace) => {
    // Create a new template object.
    let newTemplate = {}

    // Set the parent, key, value, and ID properties of the new template.
    newTemplate.parent = namespace
    newTemplate.key = ""
    newTemplate.value = ""
    newTemplate.id = `${newTemplate.parent}.${newTemplate.key}`

    // Update the templateStore by adding the new template to the templateData.
    templateStore.update((templateData) => {
      return [...templateData, newTemplate]
    })
  }
</script>

<div class="ml-3 select-none space-y-2 first:pt-0">
  <div class="flex w-full items-center justify-between pt-4">
    <p class="text-base font-medium capitalize text-gray-600 dark:text-slate-200">
      <strong>{namespace}</strong>
      Details
    </p>
  </div>
</div>
<MetadataOperations
  on:checkKey={(e) => {
    checkKeyValue = e.detail
  }}
  {json}
  {namespace}
/>
<button
  on:click|stopPropagation={() => {
    addRow(namespace)
  }}
  type="button"
  class="mx-auto mt-3 flex h-9 w-32 min-w-[36px] items-center justify-center rounded-md border border-[#a0a1a580] bg-green-500 px-2 text-sm font-medium text-white hover:bg-green-600 hover:text-white focus:outline-none focus-visible:bg-green-600 active:bg-green-500 disabled:cursor-not-allowed disabled:bg-green-300 lg:px-4"
>
  <span>
    <i class="fa-solid fa-plus" />
  </span>
  <span class="block select-none">&nbsp;Add Field&nbsp;</span>
</button>
